export default class ArrayWithRemove extends Array {
	remove(element: any) {
		const idx = this.indexOf(element);
		if (idx !== -1) {
			this.splice(idx, 1);
		}
	}
}

export const nullArray = new ArrayWithRemove();
